module.exports = __webpack_public_path__ + "img/teaser_richy3.93e27c93.jpg";